import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';
import { SET_CART_ACTIONS, SET_RETURN_ITEMS } from '../../actions/returnItems';
import { getProductAliasFromType } from '../../lib/productHelpers';

export const initialState = {
  returnItems: [],
  hasExchange: false,
  cartActions: [],
};

const EXCHANGE = getProductAliasFromType('exchange');

export default (state = initialState, { type, data: { returnItems, cartActions } = {} } = {}) => {
  switch (type) {
    case SET_RETURN_ITEMS:
      return {
        ...state,
        returnItems,
        hasExchange: returnItems.some((item) => item.product === EXCHANGE),
        hasExchangesOnly: returnItems.every((item) => item.product === EXCHANGE),
      };

    case SET_CART_ACTIONS:
      return {
        ...state,
        cartActions,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
